import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import { userSelectors } from "../../nav/selectors";
import { policies } from "../../policies/actions";
import UserGroupToggle from "../../policies/components/UserGroupToggle";
import { RoleShape } from "../../policies/proptypes";
import ActionButton from "../../shared/components/ActionButton";
import Footer from "./Footer";

class SettingsForm extends Component {
  state = {
    entityType: "group",
    name: "",
    selectedRole: "admin",
    valid: false
  };

  handleSubmit = event => {
    const { addGlobalAdminPolicy } = this.props;
    const { selectedRole, entityType, name } = this.state;
    event.preventDefault();
    addGlobalAdminPolicy(selectedRole, entityType, name);
  };

  setEntityType = type => {
    this.setState({ entityType: type });
  };

  setName = newState => {
    this.setState({ name: newState.username || newState.groupname });
  };

  setRole = role => {
    this.setState({ selectedRole: role });
  };

  setValidity = isValid => {
    this.setState({ valid: isValid });
  };

  render() {
    const { selectedRole, valid } = this.state;
    const { roles, saving } = this.props;

    if (!roles.length) {
      return null;
    }

    return (
      <form>
        <div className="l-settings__form-container">
          <h4>Add someone to RBAC</h4>
          <UserGroupToggle
            heading=""
            currentToggle={this.setEntityType}
            onUpdate={this.setName}
            isValid={this.setValidity}
          />
          <h5>Their role in RBAC</h5>
          <ul className="p-inline-list">
            {roles.map(role => (
              <li key={role.$uri} className="p-inline-list__item">
                <input
                  type="radio"
                  className="p-radio"
                  name="entityRole"
                  id={`role-${role.label}`}
                  value={role.label}
                  onChange={() => this.setRole(role.label)}
                  checked={selectedRole === role.label}
                />
                <label htmlFor={`role-${role.label}`}>{role.name}</label>
              </li>
            ))}
          </ul>
          <Footer>
            <ActionButton
              onClick={this.handleSubmit}
              onKeyPress={this.handleSubmit}
              disabled={!valid || saving}
              type="positive"
              inProgress={saving}
            >
              {`Add ${selectedRole.toLowerCase()} to RBAC`}
            </ActionButton>
          </Footer>
        </div>
      </form>
    );
  }
}

SettingsForm.propTypes = {
  addGlobalAdminPolicy: PropTypes.func.isRequired,
  roles: PropTypes.arrayOf(RoleShape).isRequired,
  saving: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  roles: userSelectors.getRbacRolesUserCanAdd(state),
  saving: state.policies.saving
});

const mapDispatchToProps = {
  addGlobalAdminPolicy: policies.addGlobalAdmin
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingsForm);
